import {
	GET_LOTS_START,
	GET_LOTS_SUCCESS,
	GET_LOTS_FAIL,
	GET_BUILDING_INFO_START,
	GET_BUILDING_INFO_SUCCESS,
	GET_BUILDING_INFO_FAIL,
	SET_LOT_SELECTED_ID,
	SET_LOT_WITH_MODEL_SELECTED,
	SET_LOTS_SELECTED,
	PUSH_LOTS_SELECTED,
	POP_LOTS_SELECTED,
	GET_CO_BROKERS_START,
	GET_CO_BROKERS_SUCCESS,
	GET_CO_BROKERS_FAIL,
	GET_SALES_AGENTS_START,
	GET_SALES_AGENTS_SUCCESS,
	GET_SALES_AGENTS_FAIL,
	SET_SHOW_AVAILABLE_LOTS,
	GET_FIT_MODELS_SUCCESS,
	GET_FIT_MODELS_FAIL,
	GET_MODEL_LOTS_SUCCESS,
	SET_LOT_SIZE_TYPE,
	SET_FILTERED_LOTS,
} from './types';

const initialState = {
	lots: [],
	availability: [],
	buildingInfo: {},
	lotSelectedId: '',
	lotWithModelSelected: {},
	lotsSelected: {},
	coBrokers: [],
	salesAgents: [],
	loading: false,
	showAvailableLots: true,
	fitModels: [],
	fitLots: [],
	coBrokerAssignedLots: [],
	lotSizeType: '',
	filteredLots: [],
};

export default function (state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case GET_LOTS_START:
			return {
				...state,
				loading: true,
			};
		case GET_LOTS_SUCCESS:
			return {
				...state,
				lots: payload.lots,
				availability: payload.availability,
				coBrokerAssignedLots: payload.coBrokerAssignedLots,
				loading: false,
			};
		case GET_LOTS_FAIL:
			return {
				...state,
				lots: [],
				availability: [],
				loading: false,
			};
		case GET_BUILDING_INFO_START:
			return {
				...state,
				loading: true,
			};
		case GET_BUILDING_INFO_SUCCESS:
			return {
				...state,
				buildingInfo: payload,
				loading: false,
			};
		case GET_BUILDING_INFO_FAIL:
			return {
				...state,
				buildingInfo: {},
				loading: false,
			};
		case SET_LOT_SELECTED_ID:
			return {
				...state,
				lotSelectedId: payload,
			};
		case SET_LOT_WITH_MODEL_SELECTED:
			return {
				...state,
				lotWithModelSelected: payload,
			};
		case SET_LOTS_SELECTED:
			return {
				...state,
				lotsSelected: payload,
			};
		case PUSH_LOTS_SELECTED:
			let pushLotsSelectedObj = {
				...state.lotsSelected,
			};
			pushLotsSelectedObj[payload] = true;
			return {
				...state,
				lotsSelected: pushLotsSelectedObj,
			};
		case POP_LOTS_SELECTED:
			let popLotsSelectedObj = {
				...state.lotsSelected,
			};
			popLotsSelectedObj[payload] = false;
			return {
				...state,
				lotsSelected: popLotsSelectedObj,
			};
		case GET_CO_BROKERS_START:
			return {
				...state,
				loading: true,
			};
		case GET_CO_BROKERS_SUCCESS:
			return {
				...state,
				coBrokers: payload,
				loading: false,
			};
		case GET_CO_BROKERS_FAIL:
			return {
				...state,
				coBrokers: [],
				loading: false,
			};
		case GET_SALES_AGENTS_START:
			return {
				...state,
				loading: true,
			};
		case GET_SALES_AGENTS_SUCCESS:
			return {
				...state,
				salesAgents: payload,
				loading: false,
			};
		case GET_SALES_AGENTS_FAIL:
			return {
				...state,
				salesAgents: [],
				loading: false,
			};
		case SET_SHOW_AVAILABLE_LOTS:
			return {
				...state,
				showAvailableLots: payload,
			};
		case GET_FIT_MODELS_SUCCESS:
			return {
				...state,
				fitModels: payload,
				loading: false,
			};
		case GET_MODEL_LOTS_SUCCESS:
			return {
				...state,
				fitLots: payload,
				loading: false,
			};
		case SET_LOT_SIZE_TYPE:
			return {
				...state,
				lotSizeType: payload,
				loading: false,
			};
		case SET_FILTERED_LOTS:
			return {
				...state,
				filteredLots: payload,
				loading: false,
			};
		default:
			return state;
	}
}
